import { configureStore as rtkConfigureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers/index';

// eslint-disable-next-line import/prefer-default-export
export const configureStore = () => {
  const store = rtkConfigureStore({
    reducer: rootReducer,
  });

  return { store };
};
